export default (url: string): Promise<string> => {
    return fetch(url)
        .then((response) => {
            if (response.status === 200) {
                return response.json().then(json => json.html_body);
            }
            throw new Error(`Failed to fetch: ${response.text()}`)
        })
}